import { FormatType } from './deck'
import { DeckListColors } from './search'

export type SubfolderFolderItemType = {
  name: string
  id: number
  private: boolean
  createdAt: string

  colors: never | undefined
  deckFormat: never | undefined
  updatedAt: never | undefined
  unlisted: never | undefined
  theorycrafted: never | undefined
  featured: never | undefined
  customFeatured: never | undefined
  edhBracket: never | undefined
  tags: never | undefined
  size: never | undefined
}

export type DeckFolderItemType = {
  name: string
  id: number
  colors: DeckListColors
  deckFormat: FormatType
  createdAt: string
  updatedAt: string
  private: boolean
  unlisted: boolean
  theorycrafted: boolean
  featured: string
  customFeatured: string
  edhBracket: number | null
  tags: any // TODO - fix
}

export const FOLDER_CELL_WIDTHS = {
  DRAG: 25,
  CHECKBOX: 45,
  FORMAT: 115,
  COLORS: 85,
  DATE: 110,
  MENU: 30,
}

export const FOLDER_ITEM_TYPES = {
  FOLDER: 'folder',
  DECK: 'deck',
  PARENT: 'parent',
  MASS: 'mass',
}

export type SelectedFolderItemType = {
  id: number
  type: string
}

export type PatchFolderItemType = {
  id: number
  type: string
  patch: Record<string, any>
}

export type FolderCreationResponse = {
  id: number
  name: string
  parentFolder: number
  private: boolean
}
